/**
 * Service info object
 * @param {object} cart cart object
 * @param {string} serviceInfoType - Service info type
 * @param {string} description - Optional description or error info
 * @returns {object} SDL object
 */
export default (cart, serviceInfoType, description) => ({
	system: {
		serviceInfo: {
			type: serviceInfoType,
			context: cart.selectedPayment.type,
			location: cart.url.href,
			description: description || ''
		}
	},
	event: 'system.serviceInfo'
});
